<template>
  <div id="app">
    <VueHeader></VueHeader>
    <VueContent></VueContent>
    <VueFooter></VueFooter>
  </div>
</template>

<script>
import VueHeader from './components/VueHeader';
import VueContent from './components/VueContent';
import VueFooter from './components/VueFooter';

export default {
  components: {
    VueHeader,
    VueContent,
    VueFooter,
  },
};
</script>

<style lang="scss">
body {
  color: #444;
  font-size: 12px;
  line-height: 1.5em;
  padding: 0;
  margin: 0;
  background: #fefefe;
  box-sizing: border-box;
  width: 100%;
  min-width: 320px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 400;
  color: #111;
  line-height: 150%;
}

h1 {
  font-size: 3.2em;
}
</style>
